module.exports = __webpack_public_path__ + "ece78c267dd4b2f3bb547ad297902fa8.MP3";